module.exports = __webpack_public_path__ + "img/logo.10da8b2e.png";